// Single-source dynamic import factory for the chat UI chunk.
// Mirrors `import-conversation-assistant.ts`: the shared `lazy()` boundary
// (`ConversationAssistantUILazy`), the control arm's warm in `ConversationAssistantConfigurer` and
// the intent-time preload all go through here so they share one chunk identity.
export const importConversationAssistantUI = (): Promise<
	typeof import('./ConversationAssistantUI')
> =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-ui" */ './ConversationAssistantUI'
	);
